import { IconCashOff, IconRosetteDiscountCheck } from "@tabler/icons-react";
import { PENDULUM_INITIAL_ANGLE_DEG, usePendulumBadge } from "$/components/use-pendulum-badge";

export function PendulumBadge() {
  const { pivotRef, badgeRef, phase } = usePendulumBadge();
  const isSwapped = phase === "swapped";

  return (
    <div ref={pivotRef} className="badge-pivot">
      {!isSwapped ? (
        <>
          <div
            ref={badgeRef}
            className="badge-base badge-pendulum badge-mensal"
            style={{ transform: `rotate(${PENDULUM_INITIAL_ANGLE_DEG}deg)` }}
          >
            <IconCashOff size={18} stroke={2.2} />
            PAGAMENTO MENSAL
          </div>

          <span className="badge-nail badge-nail--enter" aria-hidden="true" />
        </>
      ) : (
        <div className="badge-base badge-popin badge-unico">
          <IconRosetteDiscountCheck size={18} stroke={2.2} />
          PAGAMENTO ÚNICO
        </div>
      )}
    </div>
  );
}
